module.exports = __webpack_public_path__ + "img/maximiliano_frega.36f052d8.png";